import { render, staticRenderFns } from "./moritarot.vue?vue&type=template&id=580c7b03&scoped=true&"
import script from "./moritarot.vue?vue&type=script&lang=js&"
export * from "./moritarot.vue?vue&type=script&lang=js&"
import style0 from "./moritarot.vue?vue&type=style&index=0&id=580c7b03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c7b03",
  null
  
)

export default component.exports